// extracted by mini-css-extract-plugin
module.exports = {"root":"TableHeading_root__1s-uz","clinicsSelect":"TableHeading_clinicsSelect__2jGsd"};